/**
 * Units and cases, one way round.
 *
 * QUANTITIES ARE UNITS EVERYWHERE THEY ARE STORED. A case is how a brand and its manufacturer
 * talk about a quantity - "send 10 cases" - and `units_per_case` on the product is the only
 * thing that connects the two. These helpers are the whole of that conversion, so an order
 * screen, a dispatch screen and a printed document cannot disagree about what 720 units of a
 * 72-a-case product is.
 *
 * A missing or non-positive factor means the product has no case pack, and every helper here
 * answers "units only" rather than guessing.
 */
/** Whether a product carries a usable case size. */
export function hasCasePack(unitsPerCase) {
    return typeof unitsPerCase === 'number' && Number.isFinite(unitsPerCase) && unitsPerCase >= 1;
}
/** Whole cases in a unit quantity, and what does not fill one. */
export function splitIntoCases(units, unitsPerCase) {
    const whole = Math.max(0, Math.floor(units / unitsPerCase));
    return { cases: whole, loose: Math.max(0, units - whole * unitsPerCase) };
}
/**
 * The case reading of a unit quantity, for a document or a hint beside an input.
 *
 * "10 × 72" when the quantity is whole cases, "10 × 52 + 20" when it is not, and null when the
 * product has no case pack - a caller prints its own dash for that, never "0 × 0".
 */
export function formatCases(units, unitsPerCase) {
    const quantity = Number(units);
    if (!hasCasePack(unitsPerCase) || !Number.isFinite(quantity) || quantity <= 0)
        return null;
    const { cases, loose } = splitIntoCases(quantity, unitsPerCase);
    return loose === 0
        ? `${cases.toLocaleString('en-IN')} × ${unitsPerCase}`
        : `${cases.toLocaleString('en-IN')} × ${unitsPerCase} + ${loose.toLocaleString('en-IN')}`;
}
//# sourceMappingURL=caseSize.js.map